import type { ExperimentConfig } from '../@types'

// Both variants are single shared transforms, applied per-appArea on top of each funnel's base
// paywall schema (see web_compliance_jul_2026/__b.ts and __c.ts).
// US-only: enforced by the ABsmartly audience, NOT by any check in the transforms.
// Each entry has a ready test URL above it (~1 = variant B, ~2 = variant C).
const variantB = () => import('@/modules/Paywall/instances/experiments/web_compliance_jul_2026/__b')
const variantC = () => import('@/modules/Paywall/instances/experiments/web_compliance_jul_2026/__c')

const config: ExperimentConfig[] = [
	{
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_compliance_jul_2026~1
		female: { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_compliance_jul_2026~1
		'activity-female-walking': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_compliance_jul_2026~1
		'activity-female-tai-chi-walking-v2': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_compliance_jul_2026~1
		'activity-female-tai-chi-walking-v2-al': { paywall: { experiment: variantB } },
	},
	{
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_compliance_jul_2026~2
		female: { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_compliance_jul_2026~2
		'activity-female-walking': { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_compliance_jul_2026~2
		'activity-female-tai-chi-walking-v2': { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_compliance_jul_2026~2
		'activity-female-tai-chi-walking-v2-al': { paywall: { experiment: variantC } },
	},
]

export default config
